import { useQuery } from '@tanstack/react-query'

export default function useRepos(sort) {
  return useQuery({
    queryKey: ['repos'],
    staleTime: 10 * 1000,
    queryFn: async () => {
      const response = await fetch(
        `https://api.github.com/orgs/TanStack/repos?sort=${sort}`
      )
      
      if (!response.ok) {
        throw new Error(`Request failed with status: ${response.status}`)
      }

      return response.json()
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
